<template>
  <article class="wrapper">
      <div class="input-group label">
        <label> Supplier No. </label>
        <input type="text" placeholder="Supplier No.">
        <span class="iconify icon icon:uil:document"></span>
      </div>

      <div class="input-group label">
        <label> Supplier name </label>
        <input type="text" placeholder="Supplier name">
        <span class="iconify icon icon:ion:document-text-outline"></span>
      </div>

      <div class="input-group label">
        <label> Document name </label>
        <input type="text" placeholder="Document name" value="IFRS 16 - Leases Testing Workbook">
        <span class="iconify icon icon:ion:document-text-outline"></span>
      </div>

      <div class="input-group label">
        <label> Document No. </label>
        <input type="text" placeholder="Document No." value="CC.EG.11">
        <span class="iconify icon icon:ion:document-attach"></span>
      </div>
  </article>
</template>

<script>
export default {

}
</script>

<style scoped>
  .wrapper {
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 5px;
    grid-column-gap: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--element-background);
  }


  @media only screen and (max-width: 600px) {
    .wrapper {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
    }
  }
</style>